module.exports = __webpack_public_path__ + "media/app/components/DownloadApp/AppStore.a48de827.svg";